import InlineSvg, { InlineSvgIds } from 'approot/shared/inline-svg/inline-svg';
import IconMore from 'approot/shared/icons/icon-more';
import { Dropdown } from './dropdown';
import { Props } from './dropdown.constants';
import * as Styled from './dropdown-kebab.style';

type sharedProps = {
  'aria-label': string;
  menuAlignRight?: boolean;
};

export const DropdownKebab = ({
  menuAlignRight,
  $isSmallToggle,
  $noBorder,
  borderRadius,
  $iconId,
  ...rest
}: Props &
  sharedProps & {
    $isSmallToggle?: boolean;
    $noBorder?: boolean;
    $iconId?: InlineSvgIds;
  }) => {
  return (
    <Dropdown
      placement={menuAlignRight ? 'bottom-end' : rest.placement}
      fallbackPlacements={menuAlignRight ? ['top-end'] : undefined}
      borderRadius={borderRadius}
      dropdownButtonContents={
        <Styled.DropdownKebabToggle
          data-selector="kebab-menu"
          $selected={false}
          $isSmallToggle={$isSmallToggle}
          $noBorder={$noBorder}
        >
          {$iconId ? <InlineSvg id={$iconId} /> : <IconMore />}
        </Styled.DropdownKebabToggle>
      }
      {...rest}
    />
  );
};

export const DropdownSecondaryKebab = ({
  buttonElement,
  menuAlignRight,
  ...rest
}: Props & sharedProps) => (
  <Dropdown
    placement={menuAlignRight ? 'bottom-end' : undefined}
    fallbackPlacements={menuAlignRight ? ['top-end'] : undefined}
    dropdownButtonContents={
      <Styled.DropdownSecondaryKebabToggle>
        {buttonElement}
        <Styled.DropdownSecondaryKebabIcon>
          <IconMore width={12} height={12} />
        </Styled.DropdownSecondaryKebabIcon>
      </Styled.DropdownSecondaryKebabToggle>
    }
    {...rest}
  />
);
